import GestionUsuarios from './GestionUsuarios';

export default GestionUsuarios;
